import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

// Import page components
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import SectorsPage from './pages/SectorsPage';
import ProjectsPage from './pages/ProjectsPage';
import CertificationsPage from './pages/CertificationsPage';
import WhyANRPage from './pages/WhyANRPage';
import CapabilitiesPage from './pages/CapabilitiesPage';
import FAQPage from './pages/FAQPage';

const App = () => {
  const theme = useTheme();

  return (
    <Router>
      <Box sx={{ 
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${theme.palette.background.default}, ${theme.palette.grey[50]})`
      }}>
        <Header />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/sectors" element={<SectorsPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/certifications" element={<CertificationsPage />} />
          <Route path="/why-anr" element={<WhyANRPage />} />
          <Route path="/capabilities" element={<CapabilitiesPage />} />
          <Route path="/faq" element={<FAQPage />} />
        </Routes>
        
        <Footer />
      </Box>
    </Router>
  );
};

export default App;
